import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="pegboard w-full py-20 md:py-28" aria-labelledby="faq-title" data-id="element-65" data-mp="1he32gdrkuemi">
      <div className="mx-auto max-w-3xl px-5" data-id="element-66" data-mp="1cft1fmj68jsz">
        <h2 id="faq-title" className="text-center font-display text-3xl font-bold leading-tight text-ink md:text-5xl" data-id="element-67" data-mp="2a28japfifjh2">
          Frequently asked questions
        </h2>
        <ul className="mt-12 space-y-3" data-id="element-68" data-mp="253x9gep7t8yu">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white shadow-soft" data-id="element-69" data-mp="1v582vi2rraxw" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-display text-lg font-semibold text-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-teal/30" data-id="element-70" data-mp="oow3jdo7nn0q">
                  {f.q}
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ${isOpen ? 'bg-teal text-white' : 'bg-mint text-teal'}`} data-id="element-71" data-mp="1apkf8vzik3vg">
                    <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden data-id="element-72" data-mp="1fqghz684pjza" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-73" data-mp="16q1z0din0gyy">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-74" data-mp="s0w0ysvjcwsn">
                      <p className="px-6 pb-6 text-base leading-relaxed text-inkSoft" data-id="element-75" data-mp="n22l4tss0tpb">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}